import {
  ImageIcon,
  MessageSquareIcon,
  CodeIcon,
  PencilIcon,
  MusicIcon,
  VideoIcon,
} from 'lucide-react'
export type App = {
  id: string
  title: string
  author: string
  description: string
  rating: number
  reviews: string
  category: string
  icon: string
  iconBg: string
  downloads: string
  price: 'Free' | 'Paid'
  createdBy: string
  aisUsed: string[]
  updated: string
  version: string
  size: string
}
export const mockApps = [
  {
    id: 'ghiblifi',
    title: 'Ghiblifi',
    description: 'Transform your photos into Studio Ghibli style artwork',
    icon: 'image',
    iconBg: 'bg-green-500',
    category: 'Image Generation',
    rating: 4.8,
    reviews: 234,
    downloads: '12K',
    price: 'Free',
    author: 'Studio Dreams',
    createdBy: 'Studio Dreams Inc.',
    aisUsed: ['Stable Diffusion', 'Custom Model'],
    updated: '2 days ago',
  },
  {
    id: 'cooking-helper',
    title: 'Cooking Helper',
    description:
      'Your AI sous chef for personalized recipes and cooking guidance',
    icon: 'utensils',
    iconBg: 'bg-orange-500',
    category: 'Lifestyle',
    rating: 4.9,
    reviews: 567,
    downloads: '25K',
    price: 'Free',
    author: 'Chef AI',
    createdBy: 'Culinary Tech Labs',
    aisUsed: ['GPT-4', 'Custom Recipe Model'],
    updated: '1 week ago',
  },
  {
    id: 'image-wizard-pro',
    title: 'Image Wizard Pro',
    description: 'Professional AI image generation with advanced controls',
    icon: 'wand',
    iconBg: 'bg-purple-500',
    category: 'Image Generation',
    rating: 4.7,
    reviews: 892,
    downloads: '45K',
    price: '$9.99',
    author: 'Pixel Masters',
    createdBy: 'Pixel Masters Studio',
    aisUsed: ['DALL-E 3', 'Midjourney'],
    updated: '3 days ago',
  },
  {
    id: 'codecraft-ai',
    title: 'CodeCraft AI',
    description:
      'Intelligent code optimization, debugging, and explanation tool',
    icon: 'code',
    iconBg: 'bg-green-600',
    category: 'Code & Development',
    rating: 4.9,
    reviews: 1234,
    downloads: '67K',
    price: 'Free',
    author: 'DevTools Inc',
    createdBy: 'DevTools International',
    aisUsed: ['GPT-4', 'Codex'],
    updated: '1 day ago',
  },
  {
    id: 'lingua-translate',
    title: 'Lingua Translate',
    description:
      'Professional translation with context awareness and cultural nuances',
    icon: 'globe',
    iconBg: 'bg-blue-500',
    category: 'Productivity',
    rating: 4.8,
    reviews: 456,
    downloads: '34K',
    price: 'Free',
    author: 'Language AI',
    createdBy: 'Global Communications Ltd',
    aisUsed: ['GPT-4', 'Custom Translation Model'],
    updated: '2 days ago',
  },
  {
    id: 'chatmaster-ai',
    title: 'ChatMaster AI',
    author: 'Sarah Chen',
    description: 'Intelligent conversation partner for various topics',
    rating: 4.9,
    reviews: '1.8k',
    category: 'Chat & Conversation',
    icon: 'message-square',
    iconBg: 'bg-blue-500',
    downloads: '50K+',
    price: 'Free',
    createdBy: 'AI Chat Labs',
    aisUsed: ['GPT-4', 'Claude'],
    updated: 'May 15, 2023',
    version: '1.5.0',
    size: '18 MB',
  },
  {
    id: 'art-generator',
    title: 'Art Generator',
    author: 'Creative AI Labs',
    description: 'Create stunning digital art with AI',
    rating: 4.6,
    reviews: '1.2k',
    category: 'Digital Art',
    icon: 'pencil',
    iconBg: 'bg-red-400',
    downloads: '30K+',
    price: 'Free',
    createdBy: 'Creative AI Labs',
    aisUsed: ['Stable Diffusion', 'MidJourney'],
    updated: 'May 20, 2023',
    version: '1.2.0',
    size: '45 MB',
  },
  {
    id: 'story-writer',
    title: 'Story Writer',
    author: 'Narrative AI',
    description: 'AI-powered creative writing assistant',
    rating: 4.8,
    reviews: '876',
    category: 'Content Creation',
    icon: 'pencil',
    iconBg: 'bg-blue-400',
    downloads: '15K+',
    price: 'Paid',
    createdBy: 'Narrative AI Inc.',
    aisUsed: ['GPT-4', 'Claude'],
    updated: 'June 5, 2023',
    version: '1.1.0',
    size: '22 MB',
  },
  {
    id: 'music-creator',
    title: 'Music Creator',
    author: 'AI Sound Labs',
    description: 'Create original music with AI',
    rating: 4.7,
    reviews: '654',
    category: 'Audio Generation',
    icon: 'music',
    iconBg: 'bg-purple-400',
    downloads: '20K+',
    price: 'Free',
    createdBy: 'AI Sound Labs',
    aisUsed: ['MusicLM', 'AudioCraft'],
    updated: 'May 25, 2023',
    version: '1.3.0',
    size: '56 MB',
  },
  {
    id: 'video-editor',
    title: 'Video Editor AI',
    author: 'Visual AI Team',
    description: 'AI-powered video editing and enhancement',
    rating: 4.5,
    reviews: '432',
    category: 'Video Processing',
    icon: 'video',
    iconBg: 'bg-green-400',
    downloads: '10K+',
    price: 'Paid',
    createdBy: 'Visual AI Inc.',
    aisUsed: ['Runway', 'D-ID'],
    updated: 'June 8, 2023',
    version: '1.0.2',
    size: '78 MB',
  },
]
export type Review = {
  id: string
  userId: string
  userName: string
  rating: number
  comment: string
  date: string
}
export const mockReviews: Review[] = [
  {
    id: '1',
    userId: 'user1',
    userName: 'Sarah K.',
    rating: 5,
    comment: 'Great app! Really helps with my workflow.',
    date: '2023-06-01',
  },
  {
    id: '2',
    userId: 'user2',
    userName: 'Mike R.',
    rating: 4,
    comment: 'Very useful tool, but could use some UI improvements.',
    date: '2023-05-28',
  },
  {
    id: '3',
    userId: 'user3',
    userName: 'Alex M.',
    rating: 5,
    comment: 'Amazing results! Worth every penny.',
    date: '2023-06-10',
  },
]
